var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pt-3"},[_c('div',{staticClass:"col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center"},[_c('h3',{staticClass:"serif"},[_c('strong',[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"mx-5 mt-3 mb-5 border-top border-bottom"},[_c('span',{staticClass:"lh text-uppercase"},[_vm._t("category")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fe26728","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rows/PageHeader.vue
// module id = 324
// module chunks = 0